<template>
  <div
    v-if="displayTeams"
    v-tooltip="tooltipOptions"
    class="w-fit"
    :title="teamNames"
  >
    <ReportTableAvatarInitial
      :class-modifier="`avatar ${multipleTeams ? 'avatar-overlaps' : ''} avatar-medium`"
      :text="firstTeamName"
    />
    <ReportTableAvatarInitial
      v-if="displayLastTeamName"
      class-modifier="avatar avatar-overlaps avatar-medium"
      :text="lastTeamName"
    />
    <span
      v-if="displayTeamsCountBadge"
      class="more-members-badge light"
    >
      +{{ remainingTeamsNumber }}
    </span>
  </div>
  <div v-else>None</div>
</template>

<script>
import { isEmpty } from 'lodash-es';
import ReportTableAvatarInitial from '~/components/reports/ReportTableAvatarInitial.vue';

export default {
  name: 'ReportTeamsField',
  components: {
    ReportTableAvatarInitial,
  },
  props: {
    teams: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({
      html: true,
    }),
  }),
  computed: {
    displayTeams() {
      return !isEmpty(this.teams);
    },
    multipleTeams() {
      return this.displayTeams && this.teams.length > 1;
    },
    displayLastTeamName() {
      return this.displayTeams && this.teams.length === 2;
    },
    displayTeamsCountBadge() {
      return this.displayTeams && this.teams.length > 2;
    },
    teamNames() {
      return this.teams.map((team) => team.name).join(', ');
    },
    firstTeamName() {
      return this.displayTeams && this.teams[0].name;
    },
    lastTeamName() {
      return this.displayLastTeamName && this.teams[this.teams.length - 1].name;
    },
    remainingTeamsNumber() {
      return this.displayTeamsCountBadge && this.teams.length - 1;
    },
  },
};
</script>
